import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["productLevel", "termOverride", "showPricingTermsSubtext", "location", "showPricePerMonthPerSeat"];
import { HighlightedPriceDisplay } from 'pricing-pages-ui/components/common/pricing/HighlightedPriceDisplay';
import SuiteProductLevelIdentifiersMap from 'pricing-pages-ui/constants/merchCards/SuiteProductLevelIdentifiersMap';
import { hasPricingAndPurchasingSucceededSelector } from 'pricing-pages-ui/selectors/LoadingStateSelectors';
import { calculatedPriceSelector } from 'pricing-pages-ui/selectors/PricingSelectors';
import { suiteProductConfigurationsSelector } from 'pricing-pages-ui/selectors/ProductConfigsSelectors';
import { quantityPackProductConfigurationsFromProductInventorySelector } from 'pricing-pages-ui/selectors/ProductInventorySelectors';
import { useQueryParamTerm, useValidatedCrmSuiteQueryParamTerm } from 'pricing-pages-ui/utils/urls/appQueryParamUtils';
import { useSelector } from 'react-redux';
import { useAppSelector } from '../../../reducers';
import { skuIdHasBundledProductsSelector } from '../../../selectors/ProductsSelectors';
import SSM0004PricingTermsSubtext from '../../common/pricing/SSM0004PricingTermsSubtext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CrmSuitePrice = _ref => {
  let {
      productLevel,
      termOverride,
      showPricingTermsSubtext = false,
      location,
      showPricePerMonthPerSeat
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const propsToPass = Object.assign({
    showPricePerMonthPerSeat
  }, restProps);
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const {
    queryParamTerm: unbundledQueryParamTerm
  } = useValidatedCrmSuiteQueryParamTerm({
    productLevel
  });
  const suiteProductConfigurations = useSelector(state => suiteProductConfigurationsSelector(state, {
    productLevel
  }));
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const hasBundledSuite = useAppSelector(state => suiteProductConfigurations.find(config => skuIdHasBundledProductsSelector(state, {
    skuId: config.skuId
  })));
  const bundledQueryParamTerm = hasBundledSuite ? queryParamTerm : null;
  const queryParamTermToUse = termOverride || bundledQueryParamTerm || unbundledQueryParamTerm;
  const ownedQuantityPackProductConfigurations = useSelector(state => {
    return quantityPackProductConfigurationsFromProductInventorySelector(state, {
      baseProductConfigurations: suiteProductConfigurations
    });
  });

  // For bundled Suite, if this is their current plan, we still want to show
  // $/mo/seat or $/mo, not the current cost of their plan with any addt'l contacts
  const checkoutProductConfigurations = [...suiteProductConfigurations, ...(!hasBundledSuite ? ownedQuantityPackProductConfigurations : [])];
  const pricingInfo = useSelector(reduxState => {
    if (!hasPricingAndPurchasingSucceeded) return null;
    return calculatedPriceSelector(reduxState, {
      productConfigurations: checkoutProductConfigurations,
      queryParamTerm: queryParamTermToUse
    });
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HighlightedPriceDisplay, Object.assign({
      pricingInfo: pricingInfo,
      nonMerchandiseIdProduct: SuiteProductLevelIdentifiersMap[productLevel]
    }, propsToPass)), showPricingTermsSubtext ? /*#__PURE__*/_jsx(SSM0004PricingTermsSubtext, {
      productConfigurations: checkoutProductConfigurations,
      queryParamTerm: queryParamTermToUse,
      selectedTermPricingInfo: pricingInfo,
      showPricePerMonthPerSeat: showPricePerMonthPerSeat,
      location: location
    }) : null]
  });
};
export default CrmSuitePrice;